import exists from "../helpers/exists";
import {
  getCurrentSlideId,
  loadGriddFromShape,
  loadTagFromDocument,
  loadTagFromSlide,
  storeGriddOnShape,
  storeTagOnDocument,
  storeTagOnSlide,
} from "./pptapi";

export async function safeGetCurrentSlideId() {
  if (exists("PowerPoint")) {
    return getCurrentSlideId();
  } else {
    return { presId: "PRES", slideId: "SLIDE" };
  }
}

export async function safeStoreTagOnSlide(slideId, key, value) {
  if (exists("PowerPoint")) {
    return storeTagOnSlide(slideId, key, value);
  }
}

export async function safeLoadTagFromSlide(slideId, key) {
  if (exists("PowerPoint")) {
    return loadTagFromSlide(slideId, key);
  } else return null;
}

export async function safeStoreGriddOnShape(slideId, value) {
  if (exists("PowerPoint")) {
    return storeGriddOnShape(slideId, value);
  }
}

export async function safeLoadGriddFromShape(slideId) {
  if (exists("PowerPoint")) {
    return loadGriddFromShape(slideId);
  } else return null;
}

export async function safeStoreTagOnDocument(key, value) {
  if (exists("PowerPoint")) {
    return storeTagOnDocument(key, value);
  }
}

export async function safeLoadTagFromDocument(key) {
  if (exists("PowerPoint")) {
    return loadTagFromDocument(key);
  } else return null;
}
